module.exports = __webpack_public_path__ + "img/vibration.edf5b8a6.svg";